import React from 'react'
import Styled from 'styled-components'

import Icon from 'components/Icon'

const Container = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  border: 2px dashed ${props => props.theme.colors.primary.shade400};
  color: ${props => props.theme.colors.primary.shade400}
  border-radius: ${props => props.theme.radius};
  cursor: pointer;
  transition: 300ms;

  &:hover {
    border-color: ${props => props.theme.colors.primary.shade500};
    color: ${props => props.theme.colors.primary.shade500};
  }
`

const IconExtended = Styled(Icon)`
  font-size: 3rem;
  margin: 0 0 0.75rem 0;
`

const Label = Styled.div`
  font-family: ${props => props.theme.fonts.regular};
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  text-align: center;
  white-space: nowrap;
`

export default ({ onClick }) => (
  <Container onClick={onClick}>
    <IconExtended liga="add_circle" />
    <Label>Add Element</Label>
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/AddArea/index.js